<header>
  <myre-navbar>
    <ng-container center>
      <myre-nav-logo
        [redirectUrl]="[baseUrl]"
        logoUrl="assets/images/myre-symbol.svg"
      />
    </ng-container>

    <ng-container right>
      <myre-nav-menu>
        <myre-nav-menu-item>
          <myre-nav-dropdown
            [template]="userAvatar"
            [appearFrom]="'top'"
            [changeValue]="false"
            [icon]="''"
          >
            <li>
              <myre-nav-dropdown-item (selected)="signOut()">{{
                _wordings._system.logout()
              }}</myre-nav-dropdown-item>
            </li>
          </myre-nav-dropdown>
        </myre-nav-menu-item>
      </myre-nav-menu>
    </ng-container>
  </myre-navbar>
</header>

<div class="myre-container">
  <router-outlet />
</div>

<ng-template #userAvatar>
  @if (loggedUser$ | async; as loggedUser) {
    <avatar
      [email]="loggedUser.email"
      [name]="loggedUser.who"
      [imageSrc]="getAvatarUrl(loggedUser.profileImg)"
      [size]="40"
    />
  }
</ng-template>
